import { createSlice } from "@reduxjs/toolkit";
import { getNotifications, updateNotifications } from "../../api/notification";
// import { getTransactions } from "../../api/transaction";

const initialState = {
  isLoading: false,
  notificationInfo: [],
  filterItems: [],
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    getFilterItems: (state, { payload }) => {
      state.filterItems = payload;
    },
  },
  extraReducers: {
    [getNotifications.pending]: (state) => {
      state.isLoading = true;
    },
    [getNotifications.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.notificationInfo = payload;
    },
    [getNotifications.rejected]: (state) => {
      state.isLoading = false;
    },
    [updateNotifications.pending]: (state) => {
      state.isLoading = true;
    },
    [updateNotifications.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
    },
    [updateNotifications.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { getFilterItems } = notificationSlice.actions;
export const notificationSelector = (state) => state.notification;
export default notificationSlice.reducer;
